class AuthRequestResource {
    public static $inject: string[] = ["$resource", "configService"];

    constructor ($resource, configService) {
        return headers => {
            return $resource(configService.authApi.url, { active: "@active" }, {
                create: {
                    method: "POST",
                    url: `${configService.authApi.url}/v1/auth/request`,
                    // url: `${configService.authApi.url}/v1/requests`,
                    headers: headers || {}
                },
                authorize: {
                    method: "POST",
                    url: `${configService.authApi.url}/v1/admin/authorize`,
                    // url: `${configService.authApi.url}/v1/requests/:id`, // PATCH
                    headers: headers || {}
                },
                refuse: {
                    method: "POST",
                    url: `${configService.authApi.url}/v1/admin/refuse`,
                    // url: `${configService.authApi.url}/v1/requests/:id`, // PATCH
                    headers: headers || {}
                },
                query: {
                    method: "GET",
                    isArray: true,
                    url: `${configService.authApi.url}/v1/admin/request`,
                    // url: `${configService.authApi.url}/v1/requests`,
                    headers: headers || {}
                },
                getStatus: {
                    method: "GET",
                    url: `${configService.authApi.url}/v1/auth/request/:id/status`,
                    // url: `${configService.authApi.url}/v1/requests`,
                    headers: headers || {}
                }
            });
        };
    }

}

angular
    .module("thor.core.auth.request.resource", [])
    .factory("authRequestResource", AuthRequestResource);
